import { Tag, Palette, Ruler, Grid3X3, Settings, Package, Star, Zap } from "lucide-react";

export const PRODUCT_ATTRIBUTE_ICONS = {
  color: Palette,
  size: Ruler,
  material: Grid3X3,
  brand: Star,
  category: Package,
  condition: Zap,
  default: Tag,
} as const;

export const PRODUCT_ATTRIBUTE_DEFAULTS = {
  PAGE_SIZE: 20,
  DEFAULT_SORT: 'id,asc' as const,
  SORT_OPTIONS: [
    { value: 'id,asc', label: 'ID (Ascending)' },
    { value: 'id,desc', label: 'ID (Descending)' },
    { value: 'name,asc', label: 'Name (A-Z)' },
    { value: 'name,desc', label: 'Name (Z-A)' },
    { value: 'createdAt,asc', label: 'Created (Oldest First)' },
    { value: 'createdAt,desc', label: 'Created (Newest First)' },
  ] as const,
} as const;

export const PRODUCT_ATTRIBUTE_VALUE_DEFAULTS = {
  PAGE_SIZE: 20,
  DEFAULT_SORT: 'sortOrder,asc' as const,
  SORT_OPTIONS: [
    { value: 'sortOrder,asc', label: 'Sort Order (Ascending)' },
    { value: 'sortOrder,desc', label: 'Sort Order (Descending)' },
    { value: 'value,asc', label: 'Value (A-Z)' },
    { value: 'value,desc', label: 'Value (Z-A)' },
    { value: 'id,asc', label: 'ID (Ascending)' },
    { value: 'id,desc', label: 'ID (Descending)' },
  ] as const,
} as const;

export const ATTRIBUTE_TYPE_CONFIG = {
  color: {
    icon: Palette,
    color: 'text-purple-500',
    bgColor: 'bg-purple-50',
    borderColor: 'border-purple-200',
    hasColorPicker: true,
  },
  size: {
    icon: Ruler,
    color: 'text-blue-500',
    bgColor: 'bg-blue-50',
    borderColor: 'border-blue-200',
    hasColorPicker: false,
  },
  material: {
    icon: Grid3X3,
    color: 'text-green-500',
    bgColor: 'bg-green-50',
    borderColor: 'border-green-200',
    hasColorPicker: false,
  },
  brand: {
    icon: Star,
    color: 'text-yellow-500',
    bgColor: 'bg-yellow-50',
    borderColor: 'border-yellow-200',
    hasColorPicker: false,
  },
  category: {
    icon: Package,
    color: 'text-indigo-500',
    bgColor: 'bg-indigo-50',
    borderColor: 'border-indigo-200',
    hasColorPicker: false,
  },
  condition: {
    icon: Zap,
    color: 'text-orange-500',
    bgColor: 'bg-orange-50',
    borderColor: 'border-orange-200',
    hasColorPicker: false,
  },
  default: {
    icon: Tag,
    color: 'text-gray-500',
    bgColor: 'bg-gray-50',
    borderColor: 'border-gray-200',
    hasColorPicker: false,
  },
} as const;

export const ATTRIBUTE_TYPE_NAMES = Object.keys(ATTRIBUTE_TYPE_CONFIG) as Array<keyof typeof ATTRIBUTE_TYPE_CONFIG>;

export const getAttributeTypeConfig = (attributeName: string) => {
  const lowercaseName = attributeName.toLowerCase();

  for (const [type, config] of Object.entries(ATTRIBUTE_TYPE_CONFIG)) {
    if (lowercaseName.includes(type)) {
      return config;
    }
  }

  return ATTRIBUTE_TYPE_CONFIG.default;
};

export const getAttributeIcon = (attributeName: string) => {
  const config = getAttributeTypeConfig(attributeName);
  return {
    IconComponent: config.icon,
    className: `h-5 w-5 ${config.color}`,
  };
};

export const getAttributeColors = (attributeName: string) => {
  const config = getAttributeTypeConfig(attributeName);
  return {
    icon: config.icon,
    color: config.color,
    bgColor: config.bgColor,
    borderColor: config.borderColor,
    hasColorPicker: config.hasColorPicker,
  };
};

// Default store id for fetching product variants in order form context
export const DEFAULT_STORE_ID = '1';//this need to fetch from api 
